var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network"},[_c('navigation',{attrs:{"to":"/","text":"GO HOME"}}),_c('network-card'),_c('realtime-usage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }